import './index.less';
import { getEnergy, getSolar, getSolution, shopifyCartAdd } from "@utils/api.js"; // ✅ 新增 getSolution

class Dropdown {
    constructor(selector, options = {}) {
        this.dropdown = typeof selector === 'string' ? document.querySelector(selector) : selector;
        if (!this.dropdown) return;

        this.selected = this.dropdown.querySelector('.dropdown-selected');
        this.list = this.dropdown.querySelector('.dropdown-list');
        this.placeholder = options.placeholder || '请选择';
        this.onSelect = options.onSelect || function () { };

        this.init();
    }

    init() {
        const span = this.selected.querySelector('span');
        if (span && !span.textContent.trim()) span.textContent = this.placeholder;

        this.selected.addEventListener('click', (e) => {
            e.stopPropagation();
            const open = this.dropdown.classList.contains('open');
            document.querySelectorAll('.dropdown.open').forEach(d => d.classList.remove('open'));
            if (!open) this.dropdown.classList.add('open');
        });

        document.addEventListener('click', () => this.dropdown.classList.remove('open'));
    }

    setOptions(options = [], defaultValue = null) {
        this.list.innerHTML = options.map(item => `
            <div class="dropdown-item" 
                 data-value="${item.gId || item.id || item.value}"
                 data-name="${item.name}"
                 data-chargingduration="${item.chargingDuration || ''}">
              ${item.title || item.name}
            </div>`).join('');

        this.list.querySelectorAll('.dropdown-item').forEach(item => {
            item.addEventListener('click', (e) => {
                const target = e.target;
                const value = target.dataset.value;
                const label = target.textContent.trim();

                // 移除旧的选中状态
                this.list.querySelectorAll('.dropdown-item').forEach(i => i.classList.remove('selected'));
                target.classList.add('selected'); // ✅ 给当前选中项加标记

                this.selected.querySelector('span').textContent = label;
                this.dropdown.classList.remove('open');
                this.onSelect({ value, label }, this.dropdown);
            });
        });

        if (defaultValue !== null) {
            const defaultItem = this.list.querySelector(`.dropdown-item[data-value="${defaultValue}"]`);
            if (defaultItem) {
                const value = defaultItem.dataset.value;
                const label = defaultItem.textContent.trim();

                // ✅ 添加选中标记
                this.list.querySelectorAll('.dropdown-item').forEach(i => i.classList.remove('selected'));
                defaultItem.classList.add('selected');

                this.selected.querySelector('span').textContent = label;
                this.onSelect({ value, label }, this.dropdown);
            }
        }
    }

    getValue() {
        const span = this.selected.querySelector('span');
        const selectedItem = this.list.querySelector(`.dropdown-item:contains("${span.textContent.trim()}")`);
        return selectedItem ? selectedItem.dataset.value : null;
    }
}

class SmartRecommend {
    constructor() {
        this.dropdown1 = new Dropdown("#dropdown1", {
            placeholder: "",
            onSelect: ({ value }) => this.loadSolarAndPanel(value)
        });

        this.dropdown2 = new Dropdown("#dropdown2", {
            placeholder: "",
            onSelect: ({ value }) => this.updatePerformanceList(value)
        });

        this.dropdown3 = new Dropdown("#dropdown3", {
            placeholder: "",
            onSelect: ({ value }) => this.updateHourByPerformance(value)
        });

        this.calculateBtn = document.getElementById("calculateBtn");
        this.connectorBox = document.querySelector(".connector-box");
        this.greyBox = document.querySelector(".connector-grey-box");
        this.cartBtn = document.querySelector(".connector-grey-box .cart-btn");
        this.resultSection = document.querySelector(".result-section");
        this.hourDom = document.querySelector(".result-section .hours span");
        this.topBox = document.querySelector(".smart-v5 .result-top");
        this.hour = "";

        this.solarList = [];

        this.init();
    }

    async init() {
        try {
            const res = await getEnergy({});
            const energyList = res.data || [];

            if (energyList.length) {
                const defaultEnergy = energyList[0];
                this.dropdown1.setOptions(energyList, defaultEnergy.gId);
                await this.loadSolarAndPanel(defaultEnergy.gId);
            }

            // ✅ 点击计算按钮请求结果
            this.calculateBtn.addEventListener("click", () => this.handleCalculate());

        } catch (err) {
            console.error("加载电源失败：", err);
        }
    }

    async loadSolarAndPanel(energyGid) {
        try {
            const res = await getSolar({ energyGid });
            const solarList = res.data || [];
            this.solarList = solarList;

            let defaultSolarId = null;
            if (solarList.length) defaultSolarId = solarList[0].gId || solarList[0].id || solarList[0].value;
            this.dropdown2.setOptions(solarList, defaultSolarId);

            if (solarList.length) {
                this.updatePerformanceList(defaultSolarId);
            } else {
                this.dropdown3.setOptions([]);
            }
        } catch (err) {
            console.error("加载太阳能板失败：", err);
        }
    }

    updatePerformanceList(solarId) {
        const selectedSolar = this.solarList.find(
            s => String(s.gId || s.id || s.value) === String(solarId)
        );

        if (Array.isArray(selectedSolar?.solarRelResps) && selectedSolar.solarRelResps.length) {
            const performanceList = selectedSolar.solarRelResps.map(p => ({
                id: String(p.solarNum),
                name: `${p.solarNum}`,
                value: Number(p.performance),
                chargingDuration: p.chargingDuration
            }));

            const maxValue = Math.max(...performanceList.map(p => p.value));
            const defaultPerformance = performanceList.find(p => p.value === maxValue);

            this.dropdown3.setOptions(performanceList, defaultPerformance.id);
            this.hour = defaultPerformance.chargingDuration
        } else {
            this.dropdown3.setOptions([]);
        }
    }

    updateHourByPerformance(value) {
        const selectedItem = document.querySelector(`#dropdown3 .dropdown-item[data-name="${value}"]`);
        if (selectedItem) {
            const duration = selectedItem.dataset.chargingduration;
            this.hour = duration
        }
    }

    // 渲染结果dom
    renderConnectorBox(data) {
        if (!data) return;

        const box = this.greyBox;
        box.innerHTML = "";
        // 是否开启了自动折扣价
        const open_auto_discount_price = document.querySelector(".calculator-container").getAttribute("data-open-auto-discount-price") === "true"
        const current_price = Math.min(data.autoDiscountPrice || 0, data.shopifyFrontprice || 0)
        const origin_price = Math.max(data.autoDiscountPrice || 0, data.shopifyFrontprice || 0, data.shopifyFrontOriginalPrice || 0)

        // 构建 HTML
        box.innerHTML = `
    <div class="product-grey-box" data-sku-id="${data.skuId}" data-number="${data.solarNum || 1}">
      <p class="top-p">${data.title || '--'}</p>
      <div class="price">
        <span id="priceText"> ${open_auto_discount_price && data.autoDiscountPrice > 0
                ? window.formatMoney(current_price)
                : window.formatMoney(data.shopifyFrontprice, window?.pageInfo?.currency?.money_format)
            }</span>
         ${open_auto_discount_price && data.autoDiscountPrice > 0
                ? `<span class="old">${origin_price > current_price ? window.formatMoney(origin_price) : ''}</span>`
                : data.shopifyFrontprice < data.shopifyFrontOriginalPrice
                    ? `<span class="old">
                                ${window.formatMoney(data.shopifyFrontOriginalPrice, window?.pageInfo?.currency?.money_format)}
                              </span>`
                    : ""
            }
       
      </div>
      <div class="number-cart">
        <span>× ${data.solarNum ?? 1}</span>
        <div class="cart-btn">
          <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="var(--jds-color-primary)" d="M0 0h40v40H0z"/><path d="M5.714 8H9.65l1.58 19.185h18.342l5.046-14.983H14.379" stroke="#fff" stroke-width="2" stroke-linejoin="bevel"/><path d="M16 18.945h8.995M20.497 23.445V14.45M14.539 32.827c1.087 0 1.968-.88 1.968-1.968H12.57c0 1.087.881 1.968 1.968 1.968zM26.232 32.827c1.087 0 1.968-.88 1.968-1.968h-3.935c0 1.087.88 1.968 1.967 1.968z" stroke="#fff" stroke-width="2"/></svg>
        </div>
      </div>
    </div>
  `;
        // 绑定点击事件（只绑定一次）
        box.onclick = (e) => {
            if (e.target.closest(".cart-btn")) this.handleCart();
        };

        this.showResult();

    }

    async handleCalculate() {
        try {
            const energyItem = document.querySelector("#dropdown1 .dropdown-item[data-value].selected");
            const solarItem = document.querySelector("#dropdown2 .dropdown-item[data-value].selected");
            const performanceItem = document.querySelector("#dropdown3 .dropdown-item[data-value].selected");

            const energyGid = energyItem?.dataset.value;
            const solarGid = solarItem?.dataset.value;
            const solarNum = performanceItem?.dataset.value;

            const errorMsg = document.querySelector(".calculator-container").getAttribute("data-error") || ''
            const product_spu_name = document.querySelector(".calculator-container").getAttribute("data-title") || ''
            if (!energyGid || !solarGid || !solarNum) {
                pushErrorMessage(errorMsg);
                return;
            }
            // 数据埋码
            gaPushDataLayer('5.0_products_details_page_user_clicks', {
                "product_spu_name": product_spu_name || "",
                "module": 'SmartCompatible',
                "button_name": this.calculateBtn.textContent.trim(),
                "position": `${energyItem.textContent.trim()}_${solarItem.textContent.trim()}_${performanceItem.textContent.trim()}`
            })

            // ✅ 请求接口
            const res = await getSolution({
                energyGid,
                solarGid,
                solarNum
            });
            this.hourDom.textContent = this.hour || "0"

            // ✅ 更新结果显示
            if (res.data.partsProductList?.length >= 1) {
                this.renderConnectorBox(res.data.partsProductList[0]);
                this.showResult();
            }else{
                this.connectorBox?.classList.remove("active");
                this.resultSection?.classList.remove("active");
            }
        } catch (err) {
            console.error("计算结果失败：", err);
        }
    }

    handleCart() {
        const productBox = document.querySelector(".product-grey-box");
        const skuId = productBox.getAttribute('data-sku-id');
        const number = productBox.getAttribute('data-number');
        const energyItem = document.querySelector("#dropdown1 .dropdown-item[data-value].selected");
        const solarItem = document.querySelector("#dropdown2 .dropdown-item[data-value].selected");
        const performanceItem = document.querySelector("#dropdown3 .dropdown-item[data-value].selected");
        const product_spu_name = document.querySelector(".calculator-container").getAttribute("data-title") || ''
        this.addToCart([{ id: skuId, quantity: number }])

        // 数据埋码
        gaPushDataLayer('5.0_products_details_page_user_clicks', {
            "product_spu_name": product_spu_name || "",
            "module": 'SmartCompatible',
            "button_name": 'AddToCart',
            "position": `${energyItem.textContent.trim()}_${solarItem.textContent.trim()}_${performanceItem.textContent.trim()}`
        })
    }

    addToCart(items) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
        shopifyCartAdd({ items }).then(r => {
            if (cart && cart.renderContents) {
                cart.renderContents(r)
            } else {
                window.location.href = '/cart'
            }
        }).catch(err => {
            console.log(err)
        })
    }

    showResult() {
        this.connectorBox?.classList.add("active");
        this.resultSection?.classList.add("active");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new SmartRecommend();
});
